import axios from 'axios'
import { Message } from 'element-ui'
import apiEnv from '@/api/env'
import { clearAuthStorage, getToken } from './auth'

// 避免登录失效时重复跳转
let isRedirecting = false

const service = axios.create({
  baseURL: apiEnv.baseURL,
  timeout: 180000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

service.interceptors.request.use(
  config => {
    const token = getToken()
    // 文件流上传时交给浏览器自动补齐 multipart boundary
    if (config.data instanceof FormData && config.headers) {
      delete config.headers['Content-Type']
    }
    // 后端通过 usernmequityagent 请求头解析当前登录人身份
    if (token) {
      config.headers.usernmequityagent = token
    }
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    const res = response.data || {}
    if (res.status === 200 && res.result === 'success') {
      return res
    }

    const message = res.msg || '请求失败，请稍后重试'
    Message.error(message)

    // 用户信息失效时清理本地登录态
    if (message.includes('重新登录')) {
      clearAuthStorage()
      if (!isRedirecting && window.location.hash !== '#/login') {
        isRedirecting = true
        window.location.hash = '#/login'
        window.setTimeout(() => {
          isRedirecting = false
        }, 300)
      }
    }

    return Promise.reject(new Error(message))
  },
  error => {
    const message = error.message || '网络异常，请稍后重试'
    Message.error(message)
    return Promise.reject(error)
  }
)

export default service
